import localScaleManager from "../../../helpers/LocalScaleManager";
import { Helpers } from "../../../helpers/helpers";
import { tweenConfigs } from "../../../helpers/tweensConfigs";
import { WebSocketManager } from "../../../helpers/webSocketManager";

export class ShowHandMenu {
  /**
   * @param {GameScene} scene
   * @param {Table} table
   * @param {string} cardsType
   */
  constructor(scene, table, cardsType) {
    this.scene = scene;
    this.table = table;

    this.cardsList = [];
    this.shownCardsList = [];
    this.cardsBgs = [];
    this.cardsType = cardsType;

    this.setCardsLength();

    for (let i = 0; i < this.cardsLength; i++) {
      this.cardsBgs.push(
        this.scene.add
          .image(0, 0, this.scene.atlasTexture, "show-hand")
          .setInteractive({ cursor: "pointer" })
          .on("pointerdown", this.onBgClicked, [this, i])
          .setVisible(false)
      );
      this.cardsList.push(
        this.scene.add
          .image(0, 0, Helpers.getCardsSpriteSheet())
          .setVisible(false)
      );
    }
    this.table.poolArray.push(...this.cardsBgs);
    this.table.poolArray.push(...this.cardsList);
    this.cards = []; /* cards object from server */
    this.cardsBgY = 0;
    this.cardsY = 0;
  }
  onBgClicked() {
    const _this = this[0];
    const index = this[1];
    const selfPlayerSeat = _this.table.seatManager.getSelfPlayerSeat();
    if (!selfPlayerSeat) return;
    const theCardCode = _this.cardsList[index].getData("code");
    const data = {
      tableId: _this.table.tableInfo.id,
      card: theCardCode,
    };
    WebSocketManager.emitEvent(data, "poker.client-push.show-card")
      .then(() => {
        selfPlayerSeat.cards.tossACard(theCardCode);
        _this.hideAcard(index);
        _this.shownCardsList.push(theCardCode);
        // this.setInteractive();
      })
      .catch(() => {
        // this.setInteractive();
      });
  }
  setCardsLength() {
    switch (this.cardsType) {
      case "2-cardDeck": {
        this.cardsLength = 2;
        break;
      }
      case "4-cardDeck": {
        this.cardsLength = 4;
        break;
      }
      case "5-cardDeck": {
        this.cardsLength = 5;
        break;
      }
    }
  }
  handsUpdate(cards) {
    for (let i = 0; i < cards.length; i++) {
      this.cardsList[i].setTexture(
        Helpers.getCardsSpriteSheet(),
        Helpers.getCardsFrameByCode(cards[i].code)
      );
      this.cardsList[i].setData("code", cards[i].code);
      // this.cardsList[i].setData("code" , "(D)2");
    }
  }
  show() {
    const selfPlayer = this.table.gameState.playerInfo;
    if (!selfPlayer) return;
    this.handsUpdate(selfPlayer.hand);
    const alreadyShownCards = selfPlayer.showHandCards;
    this.cardsList.forEach((card, i) => {
      if (this.shownCardsList.includes(card.getData("code"))) return;
      else if (alreadyShownCards.find((c) => c.code === card.getData("code")))
        return;
      this.cardsBgs[i].setVisible(true);
      card.setVisible(true);
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this.cardsBgs[i],
          duration: tweenConfigs.actionButtons.show.duration,
          ease: tweenConfigs.actionButtons.show.ease,
          y: this.cardsBgY,
          onComplete: () => {
            this.cardsBgs[i].y = this.cardsBgY;
          },
        });
        this.scene.tweens.add({
          targets: card,
          duration: tweenConfigs.actionButtons.show.duration,
          ease: tweenConfigs.actionButtons.show.ease,
          y: this.cardsY,
          onComplete: () => {
            card.y = this.cardsY;
          },
        });
      } else {
        this.cardsBgs[i].y = this.cardsBgY;
        card.y = this.cardsY;
      }
    });
  }
  hide() {
    this.shownCardsList = [];
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: [...this.cardsBgs, ...this.cardsList],
        duration: tweenConfigs.actionButtons.hide.duration,
        ease: tweenConfigs.actionButtons.hide.ease,
        y: this.scene.gameHeight + this.cardsBgs[0].displayHeight,
        onComplete: () => {
          Phaser.Actions.SetY(
            [...this.cardsBgs, ...this.cardsList],
            this.scene.gameHeight + this.cardsBgs[0].displayHeight
          );
        },
      });
    } else {
      Phaser.Actions.SetY(
        [...this.cardsBgs, ...this.cardsList],
        this.scene.gameHeight + this.cardsBgs[0].displayHeight
      );
    }
  }
  hideAcard(index) {
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: [this.cardsBgs[index], this.cardsList[index]],
        duration: tweenConfigs.actionButtons.hide.duration,
        ease: tweenConfigs.actionButtons.hide.ease,
        y: this.scene.gameHeight + this.cardsBgs[0].displayHeight,
        onComplete: () => {
          Phaser.Actions.SetY(
            [this.cardsBgs[index], this.cardsList[index]],
            this.scene.gameHeight + this.cardsBgs[0].displayHeight
          );
        },
      });
    } else {
      Phaser.Actions.SetY(
        [this.cardsBgs[index], this.cardsList[index]],
        this.scene.gameHeight + this.cardsBgs[0].displayHeight
      );
    }
  }
  /***
   * @param width {number} width of table
   * @param height {number} height of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    const cardSize = width / 6;
    const bgSize = cardSize * 1.2;
    let cardWidth = 0,
      bgOccupiedWidth = 0,
      bgDistanceBetween = 0,
      card,
      cardBg;
    for (let i = 0; i < this.cardsList.length; i++) {
      card = this.cardsList[i];
      cardBg = this.cardsBgs[i];
      localScaleManager.scaleSprite(cardBg, bgSize, bgSize, 0, 1, true);
      localScaleManager.scaleSprite(card, cardSize, cardSize, 0, 1, true);
      if (i === 0) {
        cardWidth = card.displayWidth * 0.85;
      }
      bgDistanceBetween = cardBg.displayWidth * 0.1;
      bgOccupiedWidth = cardBg.displayWidth + bgDistanceBetween;
      cardBg.setPosition(
        initX +
          (width - bgOccupiedWidth * (this.cardsLength - 1)) / 2 +
          i * bgOccupiedWidth,
        this.scene.gameHeight - (cardBg.displayHeight * 1.1) / 2
      );
      card.setPosition(
        cardBg.x,
        cardBg.y + (cardBg.displayHeight - card.displayHeight) / 2
      );
    }
    this.cardsBgY = this.cardsBgs[0].y;
    this.cardsY = this.cardsList[0].y;
    Phaser.Actions.SetY(
      [...this.cardsBgs, ...this.cardsList],
      this.scene.gameHeight + this.cardsBgs[0].displayHeight
    );
    // this.hide();
    // setTimeout(() => {
    //     this.hide()
    // }, 2000)
    // setTimeout(() => {
    // this.show()
    // }, 5000)
  }
  /***
   * @param width {number} width of table
   * @param height {number} height of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    let cardWidth = 0,
      bgOccupiedWidth = 0,
      bgDistanceBetween = 0,
      card,
      cardBg;
    for (let i = 0; i < this.cardsList.length; i++) {
      card = this.cardsList[i];
      cardBg = this.cardsBgs[i];
      if (i === 0) {
        cardWidth = card.displayWidth * 0.85;
      }
      bgDistanceBetween = cardBg.displayWidth * 0.1;
      bgOccupiedWidth = cardBg.displayWidth + bgDistanceBetween;
      cardBg.setPosition(
        initX +
          (width - bgOccupiedWidth * (this.cardsLength - 1)) / 2 +
          i * bgOccupiedWidth,
        this.scene.gameHeight - (cardBg.displayHeight * 1.1) / 2
      );
      card.setPosition(
        cardBg.x,
        cardBg.y + (cardBg.displayHeight - card.displayHeight) / 2
      );
    }
    this.cardsBgY = this.cardsBgs[0].y;
    this.cardsY = this.cardsList[0].y;
    Phaser.Actions.SetY(
      [...this.cardsBgs, ...this.cardsList],
      this.scene.gameHeight + this.cardsBgs[0].displayHeight
    );
  }
}
